<div class="products-wrapper">
    <section class="section-block">
        <div class="container">
            <div class="row">
                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="product-list">
                        <div class="product-content">
                            <h1>
                                <p class="accessibility-plugin-ac">Co-WIN Global Outreach Program </p>
                                <!-- <p class="accessibility-plugin-ac"> Outreach Program </p> -->
                            </h1>
                            <h2 class="accessibility-plugin-ac mb-0">
                                The Co-WIN platform has been made available as a “Digital Public Good” for all the
                                nations globally. It is scalable, inclusive and open platform that serves the entire
                                public health system of nation.
                                <!-- Co-WIN is a scalable, inclusive, and open platform that
                                serves the entire public health system. <strong>The platform is
                                    available for sharing as an Open Public Good.</strong> -->
                            </h2>
                            <div class="row ">
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                                    <div class="row ">
                                        <div class="col mt-3 ">
                                            <div class="btn-block accessibility-plugin-ac"><a role="button"
                                                    class="accessibility-plugin-ac btn  btn-block"
                                                    aria-label="Get in touch" routerLink="/contact-us">Get in touch</a>
                                            </div>
                                        </div>
                                        <div class="col mt-3">
                                            <div class="btn-block accessibility-plugin-ac"><a role="button"
                                                    class="accessibility-plugin-ac btn  btn-block"
                                                    aria-label="List of certified agencies" href="#agenciesSection">List
                                                    of certified agencies</a></div>
                                        </div>


                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="product-show">
                        <div class="product-image">
                            <video width="100%" height="100%" controls>
                                <source src="https://prod-cdn.preprod.co-vin.in/assets/videos/CoWIN-Introduction.mp4"
                                    type="video/mp4">

                            </video>
                            <!-- <img role="img" aria-label="vaccination hero" src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/vaccination-hero.jpg"
                                alt="vaccination hero"> -->
                        </div>
                    </div>

                </div>


            </div>

        </div>
    </section>



    <section class="section-block solution">
        <div class="container">

            <h1 class="text-center accessibility-plugin-ac">Co-WIN Is Scaling Globally With Its Open Solutions</h1>
            <div class="scalling-box">
                <div class="text-center">
                    <div class="box-row">
                        <div class="solution-box">
                            <span class="s-icon"><img role="img" alt="feature 1"
                                    src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/feature1.svg"></span>

                            <span class="solution-text accessibility-plugin-ac">
                                <strong>Equitable vaccination</strong> at universal scale &
                                transparent distribution for all citizens
                            </span>
                        </div>
                        <div class="solution-box">
                            <span class="s-icon"><img role="img" alt="feature 2"
                                    src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/feature2.svg"></span>

                            <span class="solution-text accessibility-plugin-ac">
                                Inclusive distribution to <strong>align stakeholders</strong>

                                and remove information asymmetry
                            </span>
                        </div>
                    </div>
                    <div class="box-row">
                        <div class="solution-box">
                            <span class="s-icon">
                                <img role="img" alt="feature 3"
                                    src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/feature3.svg">
                            </span>

                            <span class="solution-text accessibility-plugin-ac">
                                <strong>Dynamic architecture</strong> that evolves and
                                accomodates change easily
                            </span>
                        </div>
                        <div class="solution-box">
                            <span class="s-icon"><img role="img" alt="feature 4"
                                    src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/feature4.svg"></span>

                            <span class="solution-text accessibility-plugin-ac">
                                Tailored interface portals for <strong>citizens,
                                    vaccinators</strong> as well as <strong>administrators </strong>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>

    <section id="agenciesSection">
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <h1 class="accessibility-plugin-ac text-center">List of Agencies - Certified for Co-WIN System
                        Integration</h1>
                </div>
            </div>
            <ul class="ageneciesList mt-2">
                <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">

                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">KPMG Assurance and Consulting
                                    Services LLP</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <img src="../../../../assets/images/KPMG-Logo.png"
                                            class="img-fluid companylogo companylogo2 ">
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">
                                                <tr>
                                                    <!-- <td> <span class="userIcon pr-1 accessibility-plugin-ac"><img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName">Debopam
                                                            Raha <br> <span
                                                                class="accessibility-plugin-ac accessibility-plugin-ac designation">Associate
                                                                Partner</span></a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td> <span class="pr-1 emailIcon accessibility-plugin-ac"><img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a class="accessibility-plugin-ac"
                                                            href="mailto: debopamraha@kpmg.com">debopamraha@kpmg.com</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table>


                                        <!-- <p><span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span> <a class="accessibility-plugin-ac" href="tel:+919830109852">+91-9830109852</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>
                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">NSDL e-Governance Infrastructure
                                    Limited</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center ">
                                            <img src="../../../../assets/images/protean_logo_vertical.png"
                                            class="img-fluid companylogo companylogo1">
                                    </div>
                                    <div class="col-md-8">
                                        <table>
                                            <p class="mb-1 userName">

                                                <tr>
                                                    <!-- <td>  <span class="userIcon pr-1 accessibility-plugin-ac">
                                                        <img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName"> Ashish
                                                            Chatterjee
                                                            <!-- <br> <span class="accessibility-plugin-ac designation">Senior Manager</span> -->
                                                        </a></td>
                                                </tr>


                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td><span class="pr-1 emailIcon accessibility-plugin-ac">
                                                            <img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"><a class="accessibility-plugin-ac"
                                                            href="mailto:AshishC@nsdl.co.in">
                                                            AshishC@nsdl.co.in</a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <!-- <table>
                                            <p>
                                                <tr>
                                                    <td>
                                                        <span
                                                            class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span>
                                                    </td>
                                                    <td valign="middle">
                                                        <a class="accessibility-plugin-ac"
                                                            href="tel:+91 896 5977 942">+91 896 5977 942</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table> -->
                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span><a class="accessibility-plugin-ac" href="tel:+919819789596">+91-9819789596</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>
                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">PricewaterhouseCoopers Pvt. Ltd.
                                </div>
                                <div class="row">
                                    <div class="col-md-4 text-center my-auto">
                                        <!-- <img src="../../../../assets/images/no-logo.png" class="img-fluid companylogo no-logo">  -->
                                        <div class="logopwc mx-auto mb-2 mb-md-0">
                                            <P>NO LOGO</P>
                                            <P>AVAILABLE</P>
                                        </div>
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">

                                                <tr>
                                                    <!-- <td>  <span class="userIcon pr-1 accessibility-plugin-ac">
                                                            <img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName"> Gautam
                                                            Sinha <br> <span
                                                                class="accessibility-plugin-ac designation">Partner</span></a>
                                                    </td>
                                                </tr>


                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td><span class="pr-1 emailIcon accessibility-plugin-ac">
                                                                <img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"><a class="accessibility-plugin-ac"
                                                            href="mailto: gautam.n.sinha@pwc.com">
                                                            gautam.n.sinha@pwc.com</a></td>
                                                </tr>
                                            </p>
                                        </table>

                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span><a class="accessibility-plugin-ac" href="tel:+919810817733">+91-9810817733</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>

                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">Trigyn Technologies Limited</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <img src="../../../../assets/images/trigyn-logo.svg"
                                            class="img-fluid companylogo trigynlogo">
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">
                                                <tr>
                                                    <!-- <td> <span class="userIcon pr-1 "><img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName">Srikiran
                                                            Yalamanchali</a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td>  <span class="pr-1 emailIcon "><img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a class="accessibility-plugin-ac"
                                                            href="mailto: srikiran.yalamanchil@trigyn.com">srikiran.yalamanchil@trigyn.com</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table>

                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon "></span><a class="accessibility-plugin-ac" href="tel:1234567890">+91-9886054233</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>


                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">KPMG Assurance and Consulting
                                    Services LLP</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <img src="../../../../assets/images/KPMG-Logo.png"
                                            class="img-fluid companylogo companylogo2 ">
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">
                                                <tr>
                                                    <!-- <td> <span class="userIcon pr-1 accessibility-plugin-ac"><img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName">Debopam
                                                            Raha <br> <span
                                                                class="accessibility-plugin-ac designation">Associate
                                                                Partner</span></a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td> <span class="pr-1 emailIcon accessibility-plugin-ac"><img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a class="accessibility-plugin-ac"
                                                            href="mailto: debopamraha@kpmg.com">debopamraha@kpmg.com</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table>


                                        <!-- <p><span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span> <a class="accessibility-plugin-ac" href="tel:+919830109852">+91-9830109852</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>
                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">NSDL e-Governance Infrastructure
                                    Limited</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center ">
                                            <img src="../../../../assets/images/protean_logo_vertical.png"
                                            class="img-fluid companylogo companylogo1">
                                    </div>
                                    <div class="col-md-8">
                                        <table>
                                            <p class="mb-1 userName">

                                                <tr>
                                                    <!-- <td>  <span class="userIcon pr-1 accessibility-plugin-ac">
                                                                <img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName"> Ashish
                                                            Chatterjee
                                                            <!-- <br> <span class="accessibility-plugin-ac designation">Senior Manager</span> -->
                                                        </a></td>
                                                </tr>


                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td><span class="pr-1 emailIcon accessibility-plugin-ac">
                                                                    <img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"><a class="accessibility-plugin-ac"
                                                            href="mailto:AshishC@nsdl.co.in">
                                                            AshishC@nsdl.co.in</a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <!-- <table>
                                            <p>
                                                <tr>
                                                    <td>
                                                        <span
                                                            class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span>
                                                    </td>
                                                    <td valign="middle">
                                                        <a class="accessibility-plugin-ac"
                                                            href="tel:+91 896 5977 942">+91 896 5977 942</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table> -->
                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span><a class="accessibility-plugin-ac" href="tel:1234567890">+91-9819789596</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>
                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">PricewaterhouseCoopers Pvt. Ltd.
                                </div>
                                <div class="row">
                                    <div class="col-md-4 text-center my-auto">
                                        <!-- <img src="../../../../assets/images/no-logo.png" class="img-fluid companylogo no-logo">  -->
                                        <div class="logopwc mx-auto mb-2 mb-md-0">
                                            <P>NO LOGO</P>
                                            <P>AVAILABLE</P>
                                        </div>
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">

                                                <tr>
                                                    <!-- <td>  <span class="userIcon pr-1 accessibility-plugin-ac">
                                                                    <img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName"> Gautam
                                                            Sinha <br> <span
                                                                class="accessibility-plugin-ac designation">Partner</span></a>
                                                    </td>
                                                </tr>


                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td><span class="pr-1 emailIcon accessibility-plugin-ac">
                                                                        <img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"><a class="accessibility-plugin-ac"
                                                            href="mailto: gautam.n.sinha@pwc.com">
                                                            gautam.n.sinha@pwc.com</a></td>
                                                </tr>
                                            </p>
                                        </table>

                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon accessibility-plugin-ac"></span><a class="accessibility-plugin-ac" href="tel:+919810817733">+91-9810817733</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>
                    <div ngxSlickItem class="slide">
                        <li>
                            <div class="card">
                                <div class="card-title accessibility-plugin-ac mb-3">Trigyn Technologies Limited</div>
                                <div class="row">
                                    <div class="col-md-4 d-flex align-items-center">
                                        <img src="../../../../assets/images/trigyn-logo.svg"
                                            class="img-fluid companylogo trigynlogo">
                                    </div>
                                    <div class="col-md-8 ">
                                        <table>
                                            <p class="mb-1 userName">
                                                <tr>
                                                    <!-- <td> <span class="userIcon pr-1 "><img src="../../../../assets/images/user.svg"></span></td> -->
                                                    <td><span class="icon-user userIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a
                                                            class="accessibility-plugin-ac companymanagerName">Srikiran
                                                            Yalamanchali</a></td>
                                                </tr>
                                            </p>
                                        </table>
                                        <table>
                                            <p>
                                                <tr>
                                                    <!-- <td>  <span class="pr-1 emailIcon "><img src="../../../../assets/images/mail.svg"></span></td> -->
                                                    <td><span class="icon-email emailIcon  pr-1"></span></td>
                                                    <td valign="middle"> <a class="accessibility-plugin-ac"
                                                            href="mailto: srikiran.yalamanchil@trigyn.com">srikiran.yalamanchil@trigyn.com</a>
                                                    </td>
                                                </tr>
                                            </p>
                                        </table>

                                        <!-- <p> <span class="icon-phone pr-2 phoneIcon "></span><a class="accessibility-plugin-ac" href="tel:+91 9886054233">+91-9886054233</a></p> -->

                                    </div>

                                </div>
                            </div>
                        </li>
                    </div>


                </ngx-slick-carousel>
            </ul>






        </div>
        <div class="mt-3 mt-lg-3">
            <div class="col-sm-10 col-12 col-md-9 col-lg-6 mx-auto">
                <div class="btn-block accessibility-plugin-ac partnerBtn">
                    <a role="button" class="accessibility-plugin-ac btn  btn-block"
                        aria-label="Learn about Certification Process" routerLink="/partner-countries">For System
                        Integrators - Learn about Certification Process</a>
                </div>
            </div>
        </div>
    </section>

    <section class="hassle-free" id="watchDemoVideosSection">
        <div class="container">
            <div class="row">

                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="list-box">
                        <div class="list-content">
                            <h1>
                                <p class="accessibility-plugin-ac">Co-WIN Empowers Citizens With <br> Hassle Free
                                    Vaccinations </p>
                                <!-- <p class="accessibility-plugin-ac"></p> -->
                            </h1>
                            <div class="hassle-free-list">
                                <ul>
                                    <li>

                                        <span class="icon-search_black_24dp-1"></span>

                                        <span class="list-txt accessibility-plugin-ac">Vaccination center &
                                            availability</span>
                                    </li>
                                    <li>

                                        <span class="icon-event_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Online vaccination slot
                                            booking</span>
                                    </li>
                                    <li>

                                        <span class="icon-verified_user_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Universally verifiable digital
                                            certificate</span>
                                    </li>
                                </ul>
                            </div>
                            <!-- <div class="btn-watch-block">
                    <a href="#" aria-label="Watch Demo Videos" class="accessibility-plugin-ac">Watch Demo Videos</a>
                </div> -->
                            <div class="btn-watch-block">
                                <a role="link" aria-label="Watch Demo Videos" class="accessibility-plugin-ac" mat-button
                                    [matMenuTriggerFor]="menu">Watch Demo Videos</a>
                                <mat-menu #menu="matMenu" role="listbox" tabindex="0">
                                    <ul class="dropdwnvideolist">
                                        <li mat-menu-item *ngFor="let vi of demoVideos" tabindex="0"
                                            [attr.aria-label]="vi.title">
                                            <a role="link" [title]="vi.title" (click)="openDialogVideo(vi)"
                                                class="accessibility-plugin-ac dropdown-item">{{vi.title}}</a>
                                        </li>
                                    </ul>
                                </mat-menu>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="video-show">
                        <div class="video-block">
                            <video width="100%" height="100%" controls>
                                <source src="https://prod-cdn.preprod.co-vin.in/assets/videos/Benefits-for-Citizens.mp4"
                                    type="video/mp4">

                            </video>
                            <!-- <img role="img" aria-label="indian certificate" src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/indian-certificate.jpg"
                                alt="indian certificate"> -->
                        </div>
                    </div>

                </div>


            </div>
        </div>

    </section>
    <section class="hassle-free facilitate">
        <div class="container">
            <div class="row">

                <div class="col-12 col-lg-6 col-sm-6 hasslefreeCol1">
                    <div class="list-box">
                        <div class="video-show">
                            <div class="video-block">
                                <video width="100%" height="100%" controls>
                                    <source
                                        src="https://prod-cdn.preprod.co-vin.in/assets/videos/CoWIN-Vaccinator-Module.mp4"
                                        type="video/mp4">

                                </video>
                                <!-- <img role="img" aria-label="Vaccinator Healthcare Workers"
                                    src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/vaccinator-healthcare-workers.jpg"
                                    alt="Vaccinator Healthcare Workers"> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-sm-6 hasslefreeCol2">
                    <div>
                        <div class="list-content">
                            <h1>
                                <p class="accessibility-plugin-ac">Facilitate Vaccine Delivery With <br> Our Vaccinator
                                    Platform</p>
                                <!-- <p class="accessibility-plugin-ac"></p> -->
                            </h1>
                            <div class="hassle-free-list">
                                <ul>
                                    <li>
                                        <span class="icon-medication_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Publish vaccination schedule &
                                            slots</span>
                                    </li>
                                    <li>
                                        <span class="icon-inventory_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Instant registrations and
                                            vaccination log</span>
                                    </li>
                                    <li>
                                        <span class="icon-how_to_reg_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Ensure citizens identity and
                                            eligibility</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="btn-watch-block "><a aria-label="Read Platform User Manual" target="_blank"
                                    href="https://prod-cdn.preprod.co-vin.in/sandbox/assets/pdf/User%20Guide_Citizen%20registration_18%2B.pdf"
                                    class="accessibility-plugin-ac">Read Platform User Manual</a></div>
                        </div>

                    </div>


                </div>


            </div>
        </div>

    </section>
    <section class="hassle-free visualize">
        <div class="container">
            <div class="row">

                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="list-box">
                        <div class="list-content">
                            <h1>
                                <p class="accessibility-plugin-ac">Visualize Vaccination Progress <br> With Analytical
                                    Dashboard</p>
                                <!-- <p class="accessibility-plugin-ac"></p> -->
                            </h1>
                            <div class="hassle-free-list">
                                <ul>
                                    <li>
                                        <span class="icon-query_stats_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Realtime tracking for
                                            registration & Vaccination</span>
                                    </li>
                                    <li>
                                        <span class="icon-people_black_24dp-1"></span>

                                        <span class="list-txt accessibility-plugin-ac">Detailed demographics for
                                            citizens vaccinated</span>
                                    </li>
                                    <li>
                                        <span class="icon-bar_chart_black_24dp-1"></span>
                                        <span class="list-txt accessibility-plugin-ac">Stats for partially and fully
                                            vaccinated citizens</span>
                                    </li>
                                </ul>
                            </div>
                            <div class="btn-watch-block"><a href="{{urls.dashboardInd}}"
                                    aria-label="View India’s Vaccination Dashboard" class="accessibility-plugin-ac"
                                    target="_blank"><span>View India’s Vaccination Dashboard</span><span
                                        class="icon-launch"></span></a></div>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-lg-6 col-sm-6">
                    <div class="video-show">
                        <div class="video-block">
                            <video width="100%" height="100%" controls>
                                <source
                                    src="https://prod-cdn.preprod.co-vin.in/assets/videos/CoWIN-Dashboard%26Benefits.mp4"
                                    type="video/mp4">

                            </video>
                            <!-- <img role="img"  aria-label="Dashboard" src="https://prod-cdn.preprod.co-vin.in/sandbox/assets/images/image.png"
                                alt="Dashboard"> -->
                        </div>
                    </div>

                </div>


            </div>
        </div>

    </section>

    <section id="cowinPlatform">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1 class="accessibility-plugin-ac">Co-WIN's Platforms Are Light, Modular & Open</h1>
                </div>
            </div>

            <ul class="platformCards mt-5">
                <li role="link" tabindex="0" aria-label="Getting Started">
                    <div class="card" routerLink="/contact-us">
                        <div class="circle switchCircle"><span class="icon-switch getStartedIcon"></span></div>
                        <a routerLink="/contact-us" class="accessibility-plugin-ac">Getting Started</a>

                    </div>
                </li>
                <li role="link" tabindex="0" aria-label="Release Notes">
                    <div class="card">
                        <div class="circle"><span class="icon-file-text-o"></span></div>
                        <a target="_blank"
                            href="https://prod-cdn.preprod.co-vin.in/sandbox/assets/docs/Release%20Notes.docx"
                            class="accessibility-plugin-ac">Release Notes</a>

                    </div>
                </li>
                <li role="link" tabindex="0" aria-label="Co-WIN Demo Videos">
                    <div class="card" target="_blank"
                        onclick="window.open('https://prod-cdn.preprod.co-vin.in/sandbox/assets/pdf/User%20Guide_Citizen%20registration_18%2B.pdf')">
                        <div class="circle">
                            <span class="icon-file-text-o"></span>
                            <!-- <span class="icon-play"></span> -->
                        </div>
                        <a target="_blank"
                            href="https://prod-cdn.preprod.co-vin.in/sandbox/assets/pdf/User%20Guide_Citizen%20registration_18%2B.pdf"
                            class="accessibility-plugin-ac">Guides & Manuals </a>

                    </div>
                </li>
                <li role="link" tabindex="0" aria-label="Platform FAQs">

                    <div class="card" routerLink="/faq">
                        <div class="circle"><span class="icon-information-outline"></span></div>
                        <a routerLink="/faq" class="accessibility-plugin-ac">Platform FAQs</a>
                    </div>

                </li>
            </ul>
            <!-- <div class="row justify-content-center">
              <div class="col-sm-9">
                 <hr>
              </div>
           </div> -->

            <!-- <div class="row platformDownloads justify-content-center mt-3">
               <div class="col-sm-12 col-md-4 col-lg-4 mr-2 downloadscol">
                <div class="row justify-content-center">
                    <div  class=" col-sm-10 ">
                     <a href="#" class="accessibility-plugin-ac">Secondary Resource Download 01</a>
                    </div>
                    <div  class=" col-sm-2 ">
                        <span class="icon-download pull-right"></span>
                    </div>
                </div>
                <hr>
               </div>
               <div class="col-sm-12 col-md-4  col-lg-4 ml-2 downloadscol">
                <div class="row justify-content-center">
                    <div  class="col-xs-8 col-sm-10 ">
                     <a href="#" class="accessibility-plugin-ac">Secondary Resource Download 02</a>
                    </div>
                    <div  class="col-xs-4 col-sm-2">
                        <span class="icon-download pull-right"></span>
                    </div>
                </div>
                <hr>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 mr-2 downloadscol">
                <div class="row justify-content-center">
                    <div  class="col-sm-10 ">
                     <a href="#" class="accessibility-plugin-ac">Secondary Resource Download 03</a>
                    </div>
                    <div  class="col-sm-2">
                        <span class="icon-download pull-right"></span>
                    </div>
                </div>
                <hr>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4 ml-2 downloadscol">
                <div class="row justify-content-center">
                    <div  class="col-sm-10 ">
                     <a href="#" class="accessibility-plugin-ac">Secondary Resource Download 04</a>
                    </div>
                    <div  class="col-sm-2">
                        <span class="icon-download pull-right"></span>
                    </div>
                </div>
                <hr>
            </div>
           </div> -->
        </div>
    </section>

    <section id="getinTouch">
        <div class="container">
            <div class="row">
                <div class="col-12 col-sm-12 col-md-8 col-lg-7 offset-lg-1">
                    <h1 class="accessibility-plugin-ac">Run Successful Vaccination Drives With Co-WIN</h1>
                </div>
                <div class="col-12 col-sm-12 col-md-4 col-lg-4">
                    <a [routerLink]="'/contact-us'" class="getintouchBtn accessibility-plugin-ac" type="button">GET
                        IN TOUCH</a>
                </div>
            </div>
        </div>
    </section>





</div>